export const getActiveTab = (path, rgx, defaultTab) => {
    const matches = path.match(rgx);

    if (matches === null) {
        return defaultTab;
    }

    return matches[1];
};